import React, { useState } from 'react';
// import Tippy from '@tippy.js/react';

import { useConnectionsByStatus } from 'connections/hooks';
import { useCurrentMember, useCurrentMemberId } from 'members/hooks/index';
import MemberAvatar from 'members/avatar/index';
import { useToggle } from '../../hooks';
import MeDropdown from './me-dropdown';
// import NavigationItem from '../item';
import { Flex, Text, Box } from 'rebass';
import { useHasDrawer } from 'app/mobile-drawer/hooks';
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import { useMyAllChildJournals } from 'account-dashboard/hooks';

const MeLink = ({ closeSidebar, isSelected = false, journalId }) => {

  const hasDrawer = useHasDrawer()
  const [on, toggle] = useToggle(true);
  const currentMemberId = useCurrentMemberId();
  const member = useCurrentMember();
  const pendingConnections = useConnectionsByStatus('pending');
  const pendingCount = (pendingConnections && pendingConnections.length) || 0;
  const [showOptions, setShowOptions] = useState(true);

  const { journals } = useMyAllChildJournals();
  const hasInitializedJournal = journals.some((journal) => journal?.state === "initialized");

  const handleClick = () => {
    toggle(!on);
    setShowOptions(!showOptions)
  };
  // const hide = () => toggle(false);

  // const showNavItem = hasDrawer && closeSidebar === undefined
  return (
    <Box>
      <Flex tabIndex="0" onClick={handleClick} justifyContent="center" alignItems="center" pt={2} sx={{ cursor: 'pointer' }}>
        <MemberAvatar size={30} id={currentMemberId} />
        {!closeSidebar && <Flex px={3} py={2} flexDirection="column" >
          <Text fontFamily="Poppins" fontWeight={500} fontSize="12px" lineHeight="20px" color="#64748B">Welcome back 👋</Text>
          <Text fontFamily="Poppins" fontWeight={500} fontSize="14px" lineHeight="20px" color="#081021">{member?.['first-name']}</Text>
        </Flex>}
        {showOptions ? <FaChevronDown /> : <FaChevronRight />}
      </Flex>

      {showOptions && (
        <MeDropdown closeSidebar={closeSidebar}
          hasInitializedJournal={hasInitializedJournal}
          isSelected={isSelected} indicatorCount={pendingCount} journalId={journalId} />
      )}
    </Box>
  );
};

export default MeLink;
